import useBackendClient from "@/client";
import { ref } from "vue";

export interface Version {
  id: string;
  name: string;
  historySeq: number | null;
  isWip: boolean;
  isLive: boolean;
  publishedDate: string | null;
  publishedBy: string | null;
  status: string;
}

export default function useVersions(appId: string) {
  const { client } = useBackendClient();
  const versions = ref<Version[]>([]);
  const loading = ref(false);

  const fetchVersions = async () => {
    loading.value = true;
    try {
      const { data } = await client.get<{ versions: Version[] }>(`/app/${appId}/version?v3=true`);
      versions.value = data.versions;
    } catch (error) {
      console.error("Failed to fetch versions", error);
    } finally {
      loading.value = false;
    }
  };

  return { versions, loading, fetchVersions };
}
